$ = require('jquery')
GroupPermissionCtrl = ($scope ,$location ,$routeParams ,groupRegisDataService ,userInfo ) ->
  if $routeParams.id is undefined || $routeParams.id == ''
    return $location.path('/groups')

  params =
    user_id : userInfo.user_id
    group_id : $routeParams.id
    status: 'approved'

  groupRegisDataService.joinGroup(params).finally ->
    $location.search('id', null)
    $location.path('/groups')

GroupPermissionCtrl.$inject = [
  '$scope'
  '$location'
  '$routeParams'
  'groupRegisDataService'
  'userInfo'
]

module.exports = GroupPermissionCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-permission-controller.coffee